import { DataMessageType, model as sse } from '!/sse'
import { model as session } from '$/session'
import { createEvent, createStore, sample } from 'effector'
import { portalRedirectModel as portal } from '~/features/portal/redirect'
import { model as signin } from '~/features/subscriber/sign-in'
import { T } from '~/shared/helpers'

// *
// * events
// *

export const init = createEvent()

export const signOut = createEvent()
export const tryAgain = createEvent()
export const openSubscribersPortal = createEvent()

export const $portalUrl = portal.$remoteSubscriberAccountSettingsURL
export const $pendingTryAgain = session.getAccountFx.pending
export const $pendingSignOut = createStore(false).on(signOut, T).reset(init)

sample({
  clock: signOut,
  target: signin.signOut,
})

sample({
  clock: tryAgain,
  fn: () => ({ refresh: true }),
  target: session.getAccountFx,
})

sample({
  clock: openSubscribersPortal,
  target: portal.navigateToAccountSettings,
})

sample({
  clock: sse.dataMessage,
  filter: (data) => data.type === DataMessageType.SUBSCRIPTION_PURCHASE_EVENT,
  fn: () => ({ refresh: true }),
  target: session.getAccountFx,
})
